import { useHelperStore } from '~/stores/helpers';
import { DEBUG, GLOBAL_MESSAGE_EVENT, type PayloadDataType } from './index';
import { useChannelsStore } from '~/stores/channels';
import type { Emitter } from '~/plugins/emitter';

type InviteNewUser = {
  eventType: 'CREATED';
  channelId: number;
  teamId: number;
  userId: number;
  inviteeEmailAddress: string;
  inviteeUserId: string;
  teamName: string;
};

const fetchMember = async (data: InviteNewUser) => {
  const emitter = useNuxtApp().$emitter as Emitter;
  const piniaChannels = useChannelsStore();
  const piniaHelpers = useHelperStore();
  await piniaChannels.channelMemberDetail({
    channelId: data.channelId,
    memberId: `${data.channelId}-${data.inviteeUserId}`,
  });
  const key = `${data.channelId}>${data.channelId}-${data.inviteeUserId}`;
  const member = piniaChannels.memberDetail[key];
  piniaHelpers.refetchInvitedMemberTable(true);
  if (member) {
    emitter.$emit(GLOBAL_MESSAGE_EVENT, {
      message: 'New member has been invited to channel.',
      status: 200,
    });
  }
};
/**
 * Handles the CREATED_INVITE pubsub event.
 *
 *
 * SIDE EFFECTS: Fetches and caches member and emits a global message.
 *
 * @param {PayloadDataType} PayloadDataType - Team member data
 *
 * @returns {Promise<void>}
 */
export async function handleSendInviteToUser(
  ...[_channel, data]: PayloadDataType<InviteNewUser>
) {
  if (DEBUG) console.log('handlePusherMessages', data);
  await fetchMember(data);
}
